/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Oral attainment projector: 5-4s with fail above 4.0.
 */
export interface GermanLegacyOralProjector {
  type?: 'german_legacy_oral';
}
